import React from "react";
import { Helmet } from "react-helmet-async";

import GlobalHero from "../components/global/GlobalHero";
import HomeAbout from "../components/global/HomeAbout";
import GlobalCta from "../components/global/GlobalCta";
import ServicesAllVans from "../components/services/ServicesAllVans";
import ServiceCategories from "../components/services/ServiceCategories";
import ServiceZones from "../components/services/ServiceZones";
import ServiceIndustries from "../components/services/ServiceIndustries";

import { servicesSections } from "../components/services/servicesSections";
import "../components/home/home.css";

const Services = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "hero":
        return (
          <GlobalHero
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            variant="services"
          />
        );

      case "fleet-tabs":
        return <ServicesAllVans key={index} />;

      case "service-categories":
        return (
          <ServiceCategories
            key={index}
            title={section.title}
            categories={section.categories}
          />
        );

      case "about":
        return (
          <HomeAbout
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            items={section.items}
            note={section.note}
            background={section.background}
          />
        );

      case "cold-chain-standards":
        return (
          <section key={index} className="service-areas container-fluid">
            <div className="container">
              <div data-aos="fade-up" data-aos-duration="800" data-aos-once="true">
                <h2 className="h2-title light-title text-center">{section.title}</h2>
                <p className="text-light text-center mx-auto mt-3 mb-5" style={{ maxWidth: "780px", fontSize: "1.6rem", lineHeight: "1.8" }}>
                  {section.description}
                </p>
              </div>

              <div className="row g-4">
                {section.items.map((item, i) => (
                  <div
                    key={i}
                    className="col-lg-4 col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="700"
                    data-aos-delay={`${(i % 3) * 100}`}
                    data-aos-once="true"
                  >
                    <div className="svc-standard-card">
                      <div className="svc-standard-num">{String(i + 1).padStart(2, "0")}</div>
                      <div className="svc-standard-icon">
                        <i className={`bi ${item.icon}`}></i>
                      </div>
                      <div className="svc-standard-title">{item.title}</div>
                      <p className="svc-standard-desc">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );

      case "zones":
        return (
          <ServiceZones
            key={index}
            title={section.title}
            zones={section.zones}
          />
        );

      case "industries":
        return (
          <ServiceIndustries
            key={index}
            title={section.title}
            industries={section.industries}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Refrigerated Transport Services in Dubai &amp; Sharjah | Chiller Fleet Transport</title>
        <meta name="description" content="Chiller Fleet Transport provides refrigerated transport services in Dubai & Sharjah for food, frozen goods & commercial cold chain logistics operations across the UAE." />
        <meta property="og:title" content="Refrigerated Transport Services in Dubai & Sharjah | Chiller Fleet Transport" />
        <meta property="og:description" content="Chiller Fleet Transport provides refrigerated transport services in Dubai & Sharjah for food, frozen goods & commercial cold chain logistics operations across the UAE." />
        <link rel="canonical" href="https://chillerfleet.com/services" />
        <meta property="og:url" content="https://chillerfleet.com/services" />
        <meta name="twitter:title" content="Refrigerated Transport Services in Dubai & Sharjah | Chiller Fleet Transport" />
        <meta name="twitter:description" content="Chiller Fleet Transport provides refrigerated transport services in Dubai & Sharjah for food, frozen goods & commercial cold chain logistics operations across the UAE." />
      </Helmet>

      {servicesSections.map(renderSection)}
    </>
  );
};

export default Services;
